<div id="panels-list" class="h-full w-full flex flex-col justify-start items-stretch" fusePerfectScrollbar>
  <mat-divider></mat-divider>
  <div class="toolbar px-6 py-2 flex flex-row justify-between items-center">
    <div class="flex flex-row justify-start items-center gap-2">
      <button
        data-testid="addPanelButton"
        i18n
        mat-stroked-button
        color="accent"
        (click)="addPanelAndSelectLast()"
        i18n-matTooltip
        matTooltip="Insert или ↓"
        *ngIf="editableOrder && !selectionMode"
        [disabled]="form.invalid"
        >Добавить панель</button
      >

      <button
        i18n
        mat-stroked-button
        (click)="importCsv()"
        *ngIf="editableOrder && !selectionMode"
        [disabled]="form.invalid"
        >Загрузить из CSV</button
      >

      <button
        i18n
        mat-stroked-button
        (click)="selectPanels()"
        *ngIf="editableOrder && !selectionMode"
        [disabled]="form.invalid"
        >Копировать</button
      >

      <button
        i18n
        mat-stroked-button
        (click)="clone()"
        *ngIf="editableOrder && selectionMode"
        [disabled]="form.invalid"
        color="accent"
        >Копировать в материал…</button
      >

      <button
        i18n
        mat-stroked-button
        (click)="cancelPanelSelection()"
        *ngIf="editableOrder && selectionMode"
        [disabled]="form.invalid"
        >Отмена</button
      >
    </div>

    <div>
      <button mat-icon-button [matMenuTriggerFor]="menu">
        <mat-icon class="mat-24">more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu" class="custom-mat-menu-panel w-96">
        <button
          [matMenuTriggerFor]="saw2FinishedMenu"
          i18n
          mat-menu-item
          *ngIf="editableOrder && !selectionMode && availabilityCommands.sawingSizes"
          >Изменить габариты панелей</button
        >
        <button
          i18n
          mat-menu-item
          (click)="concatSameSizePanels()"
          *ngIf="editableOrder && !selectionMode && availabilityCommands.mergePanelsOfSameSize"
          >Объединить панели одинакового размера</button
        >
        <button
          i18n
          mat-menu-item
          (click)="setPositionsInOrer()"
          *ngIf="editableOrder && !selectionMode && availabilityCommands.putPositionsInOrder"
          >Поставить позиции по порядку от 1…</button
        >
        <button
          i18n
          mat-menu-item
          (click)="wrapButtAlongOfPanel()"
          *ngIf="
            editableOrder &&
            !selectionMode &&
            mainMaterial.panels.length > 0 &&
            availabilityCommands.shapeThePanelAlongContour
          "
          >Облицевать панели по контуру</button
        >
        <button
          i18n
          mat-menu-item
          (click)="openShapeThePanelAlongFaceBanding()"
          *ngIf="
            editableOrder &&
            !selectionMode &&
            mainMaterial.panels.length > 0 &&
            availabilityCommands.shapeThePanelAlongFaceBanding
          "
          >Облицевать панели по пласти</button
        >
        <button
          i18n
          mat-menu-item
          (click)="replaceFaceBanding()"
          *ngIf="
            editableOrder &&
            !selectionMode &&
            mainMaterial.panels.length > 0 &&
            availabilityCommands.shapeThePanelAlongFaceBanding
          "
          >Замена облицовки пласти на деталях</button
        >
        <button
          i18n
          mat-menu-item
          (click)="deleteFaceBanding()"
          *ngIf="
            editableOrder &&
            !selectionMode &&
            mainMaterial.panels.length > 0 &&
            availabilityCommands.shapeThePanelAlongFaceBanding
          "
          >Удалить облицовку для панелей</button
        >
        <!-- <button i18n mat-menu-item (click)="setIfMissingPosition()" *ngIf="editableOrder && !selectionMode">Поставить недостающие позиции</button> -->
        <button
          mat-menu-item
          (click)="setOrientationToAllPanels((currentPanelsState = !currentPanelsState))"
          *ngIf="editableOrder && !selectionMode && availabilityCommands.removeTextureAllPanels">
          {{ getTextForChangeAllPanelOrientation() }}
        </button>
        <button i18n mat-menu-item (click)="exportCsv()" *ngIf="availabilityCommands.exportToCsv"
          >Экспортировать в CSV</button
        >
        <button i18n mat-menu-item (click)="openFieldSettingsDialog()" *ngIf="!adminMode"
          >Настройка полей таблицы</button
        >
      </mat-menu>

      <mat-menu #saw2FinishedMenu>
        <button [disabled]="countSaw2FinishedPanelsSize() === 0" i18n mat-menu-item (click)="saw2Finished()"
          >Пересчитать пильные в готовые ({{ countSaw2FinishedPanelsSize() }} шт.)</button
        >
        <button [disabled]="countFinished2SawPanelsSize() === 0" i18n mat-menu-item (click)="finished2Saw()"
          >Отменить пересчет ({{ countFinished2SawPanelsSize() }} шт.)</button
        >
      </mat-menu>
    </div>
  </div>
  <mat-divider></mat-divider>

  <form [formGroup]="form" autocomplete="off" cslPerfectScrollbar>
    <ng-container formArrayName="panels">
      <table mat-table #table [dataSource]="panelsForm.controls" cslEnterLikeTab class="w-full">
        <ng-container matColumnDef="selection">
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox
              class="mr-4"
              (change)="$event ? masterToggle() : null"
              [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()">
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row" [formGroup]="row">
            <mat-checkbox
              class="mr-4"
              (click)="$event.stopPropagation()"
              (change)="$event ? selection.toggle(row.get('uuid').value) : null"
              [checked]="selection.isSelected(row.get('uuid').value)"></mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="position">
          <th mat-header-cell *matHeaderCellDef i18n>Позиция</th>
          <td mat-cell *matCellDef="let row" [formGroup]="row">
            <ng-container *ngIf="editPanelPosition; else noEditPanelPositionTmpl">
              <mat-form-field
                appearance="outline"
                class="mini-input no-label no-subscript"
                [matTooltipDisabled]="row.get('position')?.valid"
                [matTooltip]="getError(row.get('position')?.errors)">
                <input matInput formControlName="position" />
              </mat-form-field>
            </ng-container>
            <ng-template #noEditPanelPositionTmpl>
              {{ row.get('position').value }}
            </ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell i18n *matHeaderCellDef>Наименование</th>
          <td mat-cell *matCellDef="let row" [formGroup]="row">
            <mat-form-field
              appearance="outline"
              class="mini-input no-label no-subscript w-full"
              [matTooltipDisabled]="row.get('name')?.valid"
              [matTooltip]="getError(row.get('name')?.errors)">
              <input matInput formControlName="name" />
            </mat-form-field>
          </td>
        </ng-container>

        <ng-container matColumnDef="height">
          <th mat-header-cell *matHeaderCellDef>
            <div class="flex align-center gap-0.5">
              <div i18n>Длина</div>
              <mat-icon i18n-matTooltip matTooltip="Длина готовой детали в миллиметрах" class="icon-size-4"
                >info</mat-icon
              >
            </div>
          </th>
          <td mat-cell *matCellDef="let row" [formGroup]="row">
            <mat-form-field
              appearance="outline"
              class="mini-input no-label no-subscript"
              [matTooltipDisabled]="row.get('height')?.valid"
              [matTooltip]="getError(row.get('height')?.errors)">
              <input data-testid="heightInput" matInput type="number" formControlName="height" />
            </mat-form-field>
          </td>
        </ng-container>

        <ng-container matColumnDef="width">
          <th mat-header-cell *matHeaderCellDef>
            <div class="flex align-center gap-0.5">
              <div i18n>Ширина</div>
              <mat-icon i18n-matTooltip matTooltip="Ширина готовой детали в миллиметрах" class="icon-size-4"
                >info</mat-icon
              >
            </div>
          </th>
          <td mat-cell *matCellDef="let row" [formGroup]="row">
            <mat-form-field
              appearance="outline"
              class="mini-input no-label no-subscript"
              [matTooltipDisabled]="row.get('width')?.valid"
              [matTooltip]="getError(row.get('width')?.errors)">
              <input data-testid="widthInput" matInput type="number" formControlName="width" />
            </mat-form-field>
          </td>
        </ng-container>

        <ng-container matColumnDef="orientation">
          <th mat-header-cell i18n *matHeaderCellDef>Текстура задана</th>
          <td mat-cell *matCellDef="let row" [formGroup]="row">
            <mat-checkbox formControlName="orientation"></mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="count">
          <th mat-header-cell i18n *matHeaderCellDef>Кол-во</th>
          <td mat-cell *matCellDef="let row" [formGroup]="row">
            <mat-form-field
              appearance="outline"
              class="mini-input no-label no-subscript"
              [matTooltipDisabled]="row.get('count')?.valid"
              [matTooltip]="getError(row.get('count')?.errors)">
              <input data-testid="countInput" matInput type="number" formControlName="count" />
            </mat-form-field>
          </td>
        </ng-container>

        <ng-container matColumnDef="remark">
          <th mat-header-cell i18n *matHeaderCellDef>Примечание</th>
          <td mat-cell *matCellDef="let row" [formGroup]="row">
            <mat-form-field appearance="outline" class="mini-input no-label no-subscript w-full">
              <input matInput [matMenuTriggerFor]="remarkFull" readonly [value]="row.get('remark').value" />
            </mat-form-field>

            <mat-menu #remarkFull="matMenu" class="custom-panel-remark-popup-full-edit-panel">
              <mat-form-field
                appearance="outline"
                (click)="$event.stopPropagation()"
                class="w-full dense-input no-subscript no-label"
                [matTooltipDisabled]="row.get('remark')?.valid"
                [matTooltip]="getError(row.get('remark')?.errors)">
                <textarea formControlName="remark" cols="50" rows="7" matInput appearance="outline"></textarea>
              </mat-form-field>
            </mat-menu>
          </td>
        </ng-container>

        <ng-container matColumnDef="l1">
          <th mat-header-cell *matHeaderCellDef i18n-matTooltip matTooltip="Облицовка сверху">L1</th>
          <td mat-cell *matCellDef="let row" [formGroup]="row">
            <div
              data-testid="l1Input"
              class="cursor-pointer edge-info"
              matRipple
              [cslOverflowTooltip]="row.get('l1').value?.sign || ''"
              [ngClass]="{ 'disable-pointer-events': !editableOrder || form.invalid || selectionMode }"
              enterLikeTabIgnore
              (click)="openOutlineEditorDialog(row.get('uuid').value)">
              {{ row.get('l1').value?.sign || '' }}
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="l2">
          <th mat-header-cell *matHeaderCellDef i18n-matTooltip matTooltip="Облицовка снизу">L2</th>
          <td mat-cell *matCellDef="let row" [formGroup]="row">
            <div
              data-testid="l2Input"
              class="cursor-pointer edge-info"
              matRipple
              [cslOverflowTooltip]="row.get('l2').value?.sign || ''"
              [ngClass]="{ 'disable-pointer-events': !editableOrder || form.invalid || selectionMode }"
              enterLikeTabIgnore
              (click)="openOutlineEditorDialog(row.get('uuid').value)">
              {{ row.get('l2').value?.sign || '' }}
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="w1">
          <th mat-header-cell *matHeaderCellDef i18n-matTooltip matTooltip="Облицовка слева">W1</th>
          <td mat-cell *matCellDef="let row" [formGroup]="row">
            <div
              data-testid="w1Input"
              class="cursor-pointer edge-info"
              matRipple
              [cslOverflowTooltip]="row.get('w1').value?.sign || ''"
              [ngClass]="{ 'disable-pointer-events': !editableOrder || form.invalid || selectionMode }"
              enterLikeTabIgnore
              (click)="openOutlineEditorDialog(row.get('uuid').value)">
              {{ row.get('w1').value?.sign || '' }}
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="w2">
          <th mat-header-cell *matHeaderCellDef i18n-matTooltip matTooltip="Облицовка справа">W2</th>
          <td mat-cell *matCellDef="let row" [formGroup]="row">
            <div
              data-testid="w2Input"
              class="cursor-pointer edge-info"
              matRipple
              [cslOverflowTooltip]="row.get('w2').value?.sign || ''"
              [ngClass]="{ 'disable-pointer-events': !editableOrder || form.invalid || selectionMode }"
              enterLikeTabIgnore
              (click)="openOutlineEditorDialog(row.get('uuid').value)">
              {{ row.get('w2').value?.sign || '' }}
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="editedAngles">
          <th mat-header-cell *matHeaderCellDef i18n-matTooltip matTooltip="Наличие углов с обработкой">
            <mat-icon svgIcon="vector_rectangle"></mat-icon>
          </th>
          <td mat-cell *matCellDef="let row" [formGroup]="row">
            <button
              data-testid="btnEditedAngles"
              [disabled]="!editableOrder || form.invalid || selectionMode"
              enterLikeTabIgnore
              mat-icon-button
              (click)="openOutlineEditorDialog(row.get('uuid').value, thisOutlineEditorTabsEnum.Angles)">
              <mat-icon class="mat-24" aria-label="">
                {{ isAngleEditing(row.get('uuid').value) ? 'check_box' : 'check_box_outline_blank' }}
              </mat-icon>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="slotCount">
          <th mat-header-cell *matHeaderCellDef i18n-matTooltip matTooltip="Количество пазов на панели">
            <mat-icon svgIcon="slot"></mat-icon>
          </th>
          <td mat-cell *matCellDef="let row" [formGroup]="row">
            <button
              data-testid="btnSlotCount"
              [disabled]="!editableOrder || form.invalid || selectionMode"
              enterLikeTabIgnore
              mat-icon-button
              (click)="openOutlineEditorDialog(row.get('uuid').value, thisOutlineEditorTabsEnum.Slots)">
              {{ getSlotCount(row.get('uuid').value) }}
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="fastenersExists">
          <th mat-header-cell *matHeaderCellDef i18n-matTooltip matTooltip="Наличие присадки">
            <mat-icon svgIcon="milling_cutter"></mat-icon>
          </th>
          <td mat-cell *matCellDef="let row" [formGroup]="row">
            <button
              data-testid="btnFastenersExists"
              [disabled]="!editableOrder || form.invalid || selectionMode"
              enterLikeTabIgnore
              mat-icon-button
              (click)="openOutlineEditorDialog(row.get('uuid').value, thisOutlineEditorTabsEnum.Fasteners)">
              <mat-icon aria-label="">
                {{ isFastenersExists(row.get('uuid').value) ? 'check_box' : 'check_box_outline_blank' }}
              </mat-icon>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="attachment">
          <th
            [ngStyle]="{ display: panelSetHasAttachments ? '' : 'none' }"
            mat-header-cell
            *matHeaderCellDef
            i18n-matTooltip
            matTooltip="Вложение"></th>
          <td
            [ngStyle]="{ display: panelSetHasAttachments ? '' : 'none' }"
            mat-cell
            *matCellDef="let row"
            [formGroup]="row">
            <button
              enterLikeTabIgnore
              mat-icon-button
              *ngIf="row.get('attachmentName').value"
              [matTooltip]="row.get('attachmentName').value"
              [disabled]="!editableOrder || form.invalid || selectionMode"
              (click)="openOutlineEditorDialog(row.get('uuid').value)">
              <mat-icon>attach_file</mat-icon>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="faceBandingExists">
          <th mat-header-cell *matHeaderCellDef i18n-matTooltip matTooltip="Наличие облицовки пласти">
            <mat-icon>clear_all</mat-icon>
          </th>
          <td mat-cell *matCellDef="let row" [formGroup]="row">
            <button
              data-testid="btnFaceBandingExists"
              [disabled]="!editableOrder || form.invalid || selectionMode"
              enterLikeTabIgnore
              mat-icon-button
              (click)="openOutlineEditorDialog(row.get('uuid').value, thisOutlineEditorTabsEnum.FaceBanding)">
              <mat-icon aria-label="">
                {{ isFaceBandingExists(row.get('uuid').value) ? 'check_box' : 'check_box_outline_blank' }}
              </mat-icon>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="outlineEditor">
          <th mat-header-cell *matHeaderCellDef i18n-matTooltip matTooltip="Редактор контура">
            <mat-icon svgIcon="square_edit_outline"></mat-icon>
          </th>
          <td mat-cell *matCellDef="let row" [formGroup]="row">
            <button
              enterLikeTabIgnore
              mat-icon-button
              [disabled]="form.invalid || selectionMode"
              (click)="openOutlineEditorDialog(row.get('uuid').value)">
              <mat-icon aria-label="">rounded_corner</mat-icon>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="delete">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row" [formGroup]="row">
            <button
              data-testid="btnDelete"
              enterLikeTabIgnore
              mat-icon-button
              [disabled]="!editableOrder || selectionMode"
              (click)="deletePanel(row.get('uuid').value)">
              <mat-icon aria-label="">delete</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="getDisplayedColumns(); sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: getDisplayedColumns()"></tr>
      </table>
    </ng-container>
  </form>
</div>
